<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('citiesList.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-3 almarai-bold" aria-current="page">{{$t('citiesList.breadcrumb_2')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div v-if="isLoading" class="text-center">
      <mainloader />
    </div>
    <div v-else class="row">
      <div class="col">
        
        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
        <div class="row justify-content-center">
          <div class="col-12 col-md-8">
            <div class="mb-3 position-R">
              <i class="fa-solid fa-magnifying-glass search-icon"></i>
              <input type="text" v-model="search" @keypress="citiesFilter" class="form-control input-style" :placeholder="$t('citiesList.search')" aria-label="Username" aria-describedby="basic-addon1">
            </div>
          </div>
        </div>


        <div class="row pt-4">
          <div class="col-6 col-md-auto mb-4" v-for="(row,index) in rows" :key="index">
            <router-link :to="'/propertielist?cityId='+row.id">
              <img v-if="row.cover" :src="MEDIA_URL+row.cover" class="style-img width-170" alt="">
              <img v-else src="/assets/images/placeHolder.jpeg" class="style-img" alt="">
            </router-link>
            <!-- <div>{{ row.name }}</div> -->
          </div>
        </div>

        <div v-if="!rows.length" class="row justify-content-center pt-5">
          <div class="col text-center">
            <div class="row">
              <div class="col">
                <div><img src="/assets/images/icons/Frame_22.png" class="w-prcentage-12" alt=""></div>
                <h4 class="pt-4 fonttext-14">{{$t('citiesList.notFound')}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "citiesList",
  data(){
    return{
      regionId: this.$route.query.regionId,
      isLoading: true,
      hasError: false,
      message: "",
      errorNumber: 0,
      rows: [],
      userLang: 'ar',
      search: ""
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL','GET_USER  '])
  },
  methods:{
    citiesList(){
      this.hasError = false;
      this.$http.get("/api/cities/list?regionId="+this.regionId).then(res => {
        // console.log(res);
        this.rows = res.data.cities;
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false
        [this.message, this.errorNumber] = this.$globalError(err,true);
        this.searchError = true;
      });
    },

    citiesFilter(){
      this.rows.filter((ctiyName)=> {
        console.log('step1');
        return ctiyName.name;
      })
    }
  },
  created(){
    this.citiesList();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>